import {
  TONE_COLOR_DARK_HEX_FIELD_DICT,
  TONE_COLOR_LIGHT_HEX_FIELD_DICT,
  type ToneNumber,
} from "@-/dev.improve.haniverse.lib.actor.types";
import { useActorUser } from "@-/dev.improve.haniverse.lib.user";
import { useTheme } from "@-/dev.improve.haniverse.lib.theme";
import { useMemo } from "react";

export function useActorToneColors() {
  const userSettings = useActorUser();
  const colorScheme = useTheme();

  return useMemo(() => {
    const fields =
      colorScheme === "dark" ? TONE_COLOR_DARK_HEX_FIELD_DICT : TONE_COLOR_LIGHT_HEX_FIELD_DICT;
    return {
      0: userSettings[fields[0]],
      1: userSettings[fields[1]],
      2: userSettings[fields[2]],
      3: userSettings[fields[3]],
      4: userSettings[fields[4]],
    } satisfies Record<ToneNumber, string>;
  }, [userSettings, colorScheme]);
}
